<template>
    <div class="property-listing card rounded-3" :class="border ? 'border' : 'border-0'">
        <div class="listing-img-wrapper p-3">
            <div class="list-img-slide position-relative">
                <a :href="props.item.link" target="_blank" rel="noopener noreferrer">
                    <div class="rounded-3 overflow-hidden mb-0 slick-slider" data-overlay="3">
                        <img :src="props.item.image" class="img-fluid" alt="">
                    </div>
                </a>
            </div>
        </div>
        <div class="listing-caption-wrapper px-3">
            <div class="listing-detail-wrapper">
                <div class="listing-short-detail-wrap">
                    <div class="listing-short-detail">
                        <div class="d-flex align-items-center">
                            <!-- <span v-if="item.tag2 === 'For Rent'" class="label bg-light-success text-success prt-type me-2">For Rent</span>
                            <span v-if="item.tag2 === 'For Sell'"  class="label bg-light-danger text-danger prt-type me-2">For Sell</span> -->
                            <span class="label bg-light-purple text-purple property-cats">{{categoryName}}</span>
                        </div>
                        <div class="prt-location text-muted-2 d-flex align-items-center"><span class="svg-icon svg-icon-2hx"></span>{{stateName}}</div>
                    </div>
                </div>
            </div>
            <!-- <div class="price-features-wrapper">
                <div class="list-fx-features d-flex align-items-center justify-content-between">
                    <div class="listing-card d-flex align-items-center">
                        <div class="square--25 text-muted-2 fs-sm circle gray-simple me-1"><i class="fa-solid fa-building-shield fs-xs"></i></div><span class="text-muted-2 fs-sm">{{item.size}}</span>
                    </div>
                    <div class="listing-card d-flex align-items-center">
                        <div class="square--25 text-muted-2 fs-sm circle gray-simple me-1"><i class="fa-solid fa-bed fs-xs"></i></div><span class="text-muted-2 fs-sm">{{item.beds}}</span>
                    </div>
                    <div class="listing-card d-flex align-items-center">
                        <div class="square--25 text-muted-2 fs-sm circle gray-simple me-1"><i class="fa-solid fa-clone fs-xs"></i></div><span class="text-muted-2 fs-sm">{{item.sqft}}</span>
                    </div>
                </div>
            </div> -->
            <!-- <div class="listing-detail-footer d-flex align-items-center justify-content-between py-4">
                <div class="listing-short-detail-flex">
                    <h6 class="listing-card-info-price m-0">{{item.value}}</h6>
                </div>
                <div class="footer-flex">
                    <router-link to="/single-property-1" class="prt-view">
                        <span class="svg-icon text-primary svg-icon-2hx">
                            <img :src="send" alt=""/>
                        </span>
                    </router-link>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script setup>
import { computed ,defineProps} from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  item: Object,
  border: Boolean
});

const { locale } = useI18n();

const categoryName = computed(() => {
  if (!props.item.category) return '';
  return locale.value === 'ar' ? props.item.category.name_ar : props.item.category.name;
});

const stateName = computed(() => {
  if (!props.item.state) return '';
  return locale.value === 'ar' ? props.item.state.name_ar : props.item.state.name;
});
</script>


